import React, { useRef, useState, useEffect } from "react";
// import { ArrowDown } from "lucide-react"; // or any arrow icon you're using
import { ReactComponent as ArrowDown } from "../../assets/icons/components/common/table/select.svg";


const CustomSelect = ({
  title = "",
  isRequired = false,
  options = [],
  selected = null,
  onSelection = () => {},
  readOnly = false,
  placeholder = "Choose something",
  className = "",
  innerClassName = "",
  inputStyle = {},
  innerStyle = {},
  itemContainerStyle = {},
  titleStyle = {},
  style = {},
  toolTip = "",
  focusWithinProps = {},
  processing = false,
  whiteBackground = false,
  disabled = false,
  register = {},
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef();
  const containerRef = useRef();
  const dropdownRef = useRef();

  const optionSelected = (option) => {
    onSelection(option);
    setIsOpen(false);
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both container and dropdown
      const isClickInsideContainer = containerRef.current?.contains(event.target);
      const isClickInsideDropdown = dropdownRef.current?.contains(event.target);
      
      if (!isClickInsideContainer && !isClickInsideDropdown) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      // Use 'click' instead of 'mousedown' for better compatibility
      document.addEventListener("click", handleClickOutside, true);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [isOpen]);

  const displayValue =
    typeof selected === "object"
      ? selected?.name
      : options?.find((opt) => opt.value === selected)?.name || "";

  return (
    <div
      ref={containerRef}
      title={toolTip}
      className={`d-flex flex-column align-items-start ${className}`}
      style={{ width: "100%", ...style }}
      tabIndex={-1}
      {...focusWithinProps}
    >
      {title && (
        <div
          className="mb-2"
          style={{ minWidth: "fit-content", paddingLeft: "24px" }}
        >
          <span style={{ ...titleStyle }} className="body-2 dark-50">
            {title}
            {isRequired && <span className="danger-text">*</span>}
          </span>
        </div>
      )}

      <div className="select-container" style={{ ...innerStyle }}>
        <input
          readOnly={readOnly}
          ref={selectRef}
          className={innerClassName}
          style={{
            cursor: disabled ? "not-allowed" : "pointer",
            backgroundColor: whiteBackground ? "white" : "",
            ...inputStyle,
          }}
          value={displayValue}
          disabled={disabled}
          placeholder={placeholder}
          onClick={(e) => {
            if (!readOnly && !disabled) {
              e.stopPropagation();
              setIsOpen(!isOpen);
            }
          }}
          {...register}
        />
        <ArrowDown className="arrow-icon" />

        {isOpen && (
          <>
            {processing ? (
              <div className="loader-container" ref={dropdownRef}>
                <span className="processing-indicator-wrapper small-indicator">
                  <span className="processing-indicator grey" />
                </span>
              </div>
            ) : (
              <div
                ref={dropdownRef}
                className="menu-items-container"
                style={{ ...itemContainerStyle }}
              >
                {options?.map((option, i) => (
                  <div
                    key={i}
                    className="menu-item-container"
                    onClick={(e) => {
                      e.stopPropagation();
                      optionSelected(option);
                    }}
                  >
                    <span style={{ textAlign: "start" }}>{option.name}</span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CustomSelect;
